import { render } from "./WithdrawalForm.vue?vue&type=template&id=71c51709&scoped=true"
import script from "./WithdrawalForm.vue?vue&type=script&lang=js"
export * from "./WithdrawalForm.vue?vue&type=script&lang=js"

import "./WithdrawalForm.vue?vue&type=style&index=0&id=71c51709&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c51709"]])

export default __exports__